<div class="At-Wrapper" id="myWrapper">
  <header class="At-MainHeader">
    <app-header></app-header>
  </header>
  <!-- header ends -->
  <div class="At-PageContent">
    <router-outlet></router-outlet>
  </div>
  <!-- At-PageContent ends -->
</div>
